import { Typography } from '@mui/material';
import { formatPhone } from 'utils/phone-format-helpers';

const PhoneNumber = ({ number }: { number: string }) => {
  return (
    <Typography color="text.primary" component="span">
      {formatPhone(number)}
    </Typography>
  );
};

export default PhoneNumber;
